enum FOOTER_PAGE_TYPE {
  NORMAL = 'NORMAL',
  HIDE = 'HIDE',
}

export default FOOTER_PAGE_TYPE;
